export default __webpack_public_path__ + "static/media/portfolioramirez.2a29e73c.png";